import { useDataChange, useDataValue } from 'Simple/Data.js'
export function useOnChange(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'event_action',
  })
  return function onChange() {
    change(next => {
      next.data = {
        ...next.data,
        actions: [{ id: 'letter', document_template_id: null }],
      }
    })
  }
}
